module.exports = __webpack_public_path__ + "img/ojkaQ5VnM0xgtlzjU6S_5HFZ1CrY.6504a44a.jpg";